import { render, staticRenderFns } from "./CarouselLazyLoading.vue?vue&type=template&id=54fe020c&scoped=true&"
import script from "./CarouselLazyLoading.vue?vue&type=script&lang=js&"
export * from "./CarouselLazyLoading.vue?vue&type=script&lang=js&"
import style0 from "./CarouselLazyLoading.vue?vue&type=style&index=0&id=54fe020c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fe020c",
  null
  
)

export default component.exports